import { useSnackbar } from 'notistack';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';

import { Defect } from '@/types';
import { useDeleteDefectMutation } from '@/services';

export interface DeleteDefectProps extends DialogProps {
  defect: Defect;
  onClose(): void;
}

const DeleteDefect: React.FC<DeleteDefectProps> = ({ defect, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [deleteDefect, deleteDefectResponse] = useDeleteDefectMutation();

  async function handleDeleteDefect() {
    try {
      await deleteDefect(defect).unwrap();

      onClose();
    } catch (error) {
      enqueueSnackbar(error.data, { variant: 'error' });
    }
  }

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">{defect?.name}</DialogTitle>

      <DialogContent dividers>
        <DialogContentText>Вы действительно хотите удалить "{defect?.name}"?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button color="secondary" variant="outlined" disabled={deleteDefectResponse.isLoading} onClick={onClose}>
          Закрыть
        </Button>

        <Button variant="contained" disabled={deleteDefectResponse.isLoading} onClick={handleDeleteDefect}>
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDefect;
